var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.506 6.033a.77.77 0 0 1-.303.612L7.67 11.196a.775.775 0 0 1-1.092.002.762.762 0 0 1-.001-1.092l3.285-3.299-8.891.018A.766.766 0 0 1 .2 6.057c0-.43.337-.77.768-.77l8.905-.018-3.306-3.293A.762.762 0 0 1 6.566.884.762.762 0 0 1 7.658.882l4.624 4.605a.739.739 0 0 1 .15.215.77.77 0 0 1 .074.331Z",
    clipRule: "evenodd"
  })));
};
export default SvgRightArrow;